import Axios from "axios";

const base_url = "cp/trips";

export default {
    /**
     * Display a listing of the Trips.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(`${base_url}?page=${page}`, { params });
    },

    /**
     * Store a new Trip in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Show data for a given Trip.
     *
     * @param {int} id
     * @returns {Promise}
     */
    getById(id) {
        return Axios.get(`${base_url}/${id}`);
    },

    /**
     * Update the given Trip in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(`${base_url}/${data.id}`, data);
    },

    /**
     * Update the given Trip shipment status in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    updateShipment(trip, shipment, data) {
        return Axios.put(`${base_url}/${trip}/${shipment}`, data);
    }

    /**
     * Remove the specified Trip from server.
     *
     * @param {int} id
     * @returns {Promise}
     */
    //delete(id) {
    //    return Axios.delete(`${base_url}/${id}`);
    //}
};
